import React from 'react';

import { Typography, Stack, Divider } from '@mui/material';

interface DashboardProps {
    coverratiodata?: {
        in_edelivery?: number;
        not_in_edelivery?: number;
    };
}

const StatTile = ({ id, label, value }) => (
    <Stack
        direction="column"
        spacing={0.5}
        alignItems="flex-start" // Aligns the label and value to the left
        sx={{ flexGrow: 1, px: 2, textAlign: 'left' }}
    >
        <Typography
            variant="body2"
            sx={{
                color: 'text.secondary',
                fontSize: '1.2rem',
                lineHeight: 1.2,
            }}
        >
            {label}
        </Typography>
        <Typography
            variant="h5"
            sx={{
                fontWeight: '600',
                fontSize: '1.8rem',
                color: id === 3 ? 'error.main' : 'text.primary',
                minWidth: 40,
            }}
        >
            {value}
            {id === 4 && '%'}
        </Typography>
    </Stack>
);

export default function DashboardStats({ coverratiodata }: DashboardProps) {
    const { in_edelivery = 0, not_in_edelivery = 0 } = coverratiodata || {};

    const total = in_edelivery + not_in_edelivery;
    const coverRatio = total > 0 ? ((in_edelivery / total) * 100).toFixed(2) : '0.00';

    return (
        <Stack
            direction="row"
            divider={<Divider orientation="vertical" flexItem sx={{ my: 1, color: 'grey' }} />}
            spacing={1}
            alignItems="center"
            justifyContent="space-around" // Spreads tiles evenly
        >
            <StatTile id={1} label="Mission Total" value={total} />
            <StatTile id={2} label="Mission In e-Delivery" value={in_edelivery} />
            <StatTile id={3} label="Mission Not In e-Delivery" value={not_in_edelivery} />
            <StatTile id={4} label="Cover Ratio" value={coverRatio} />
        </Stack>
    );
}
